import type { DiscoveredRouteModule } from '@/router/generator/types';

const BadRequestView = () => import('@/views/error-pages/BadRequestView.vue');
export const NAME_BAD_REQUEST = 'BadRequest';
export const PATH_BAD_REQUEST = '/bad-request';

export const route: DiscoveredRouteModule = {
  id: 'root.error.bad_request',
  scope: 'root',
  name: NAME_BAD_REQUEST,
  path: PATH_BAD_REQUEST,
  component: BadRequestView,
  meta: { isErrorPage: true, requiresAuth: false, skipProjectCheck: true, skipPermissionCheck: true },
};


